import { Component, inject } from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions, MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { SubscriptionPlan } from '@shared/interfacres/user';
import { PlanSelect } from '@shared/components/plan-select/plan-select';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

export interface PlansData {
  activePlanId?: string;
  plans: SubscriptionPlan[];
  showCancel?: boolean;
  showPromoField?: boolean;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: 'plan-select-dialog.html',
  imports: [
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    PlanSelect,
    MatDialogClose,
    ReactiveFormsModule,
  ],
})
export class PlanSelectDialog {
  readonly dialogRef = inject(MatDialogRef<PlanSelectDialog>);
  readonly data = inject<PlansData>(MAT_DIALOG_DATA);
  activePlanId = '';
  showCancel = false;
  showPromoField = false;

  promoCode = new FormControl(null);
  planId = '';

  constructor() {
    if (this.data.activePlanId) {
      this.activePlanId = this.data.activePlanId;
    }
    if (this.data.showCancel) {
      this.showCancel = this.data.showCancel;
    }

    this.showPromoField = !!this.data.showPromoField;

  }

  selectPlan(planId: string) {
    if (this.showPromoField) {
      this.planId = planId;
      this.activePlanId = planId;
      return;
    }
    this.dialogRef.close(planId);
  }

  save() {
    if (!this.planId || this.planId === '' ) {
      return;
    }
    this.dialogRef.close({
      planId: this.planId,
      promoCode: this.promoCode.value
    });
  }
}
